import { CampusWardSessionInformation } from './campus-ward-session-information.model';
import { ApprovedAddress } from './approved-address.model';

export class SelectableCampusWardSessionInformation  {
    selectedAddresses: ApprovedAddress[];
    campusWardSessionInformation: CampusWardSessionInformation;

    constructor(campusWardSessionInformation: CampusWardSessionInformation) {
        this.campusWardSessionInformation = campusWardSessionInformation;
        this.selectedAddresses = [];
    }
}
